import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CostCalculationService } from '../../../Services/cost-calculation.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { Router } from '@angular/router';
import { AuthService } from '../../../Shared/Services/auth.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { SectorProductComparisonRequestDTOVM } from '../../../Model/cost-calculation/SectorProductComparison/SectorProductComparisonRequestDTOVM';
import { SectorProductComparisonResponseDTOVM } from '../../../Model/cost-calculation/SectorProductComparison/SectorProductComparisonResponseDTOVM';
import { SectorVM } from '../../../Model/SectorVM';
import { ChartOptions } from '../../../Shared/Models/ChartOptions';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-sector-product-comparison',
  templateUrl: './sector-product-comparison.component.html',
  styleUrl: './sector-product-comparison.component.scss'
})
export class SectorProductComparisonComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  @Input() Product: SectorProductComparisonRequestDTOVM = {};
  @Output() IsSectorProductComparison = new EventEmitter<boolean>();
  AllSectors?: SectorVM[] = [];

  public columnChartOptions: Partial<ChartOptions> | any;
  constructor(private api: CostCalculationService, private router: Router, private toastrService: CustomToastrService,
    private spinner: NgxSpinnerService, private auth: AuthService, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      this.columnChartOptions = {
        series: [{ name: "", data: [] }],
        chart: { height: 300, type: 'bar', stacked: true }
      };
      this.GetSector();
      this.SectorProductComparison();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetSector() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.api.GetSector()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.AllSectors = data;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ChooseSector(sectorId?: number) {
    this.spinner.show();
    if (sectorId != null) {
      this.Product.SectorIds?.push(sectorId);
    }

    this.SectorProductComparison();
  }

  SectorProductComparison() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.api.SectorProductComparison(this.Product)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.SetChartData(data);
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBack',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.IsSectorProductComparison.emit(false);
      }
    });
  }

  SetChartData(res?: SectorProductComparisonResponseDTOVM[]) {
    let categories: string[] = [];
    let sectorTotalCost: number[] = [];
    let series: any[] = [];
    res?.map((a: SectorProductComparisonResponseDTOVM) => {
      categories.push(a.sectorName!);
      sectorTotalCost.push(a.sectorTotalCost!);
      series.push({ name: a.sectorName, data: sectorTotalCost })
    });

    setTimeout(() => {
      this.columnChartOptions = {
        series: [
          {
            name: "",
            data: sectorTotalCost
          }
        ],
        chart: {
          height: 300,
          type: 'bar',
          stacked: true,
        },
        plotOptions: {
          bar: {
            columnWidth: '40%',
            barHeight: '40%',
          },
        },
        grid: {
          show: true,
          strokeDashArray: 0,
          borderColor: 'rgba(0,0,0,0.1)',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          //type: 'category',
          categories: categories,
        },
        tooltip: {
          theme: 'light',
        },
      };

      this.spinner.hide();
    }, 600);
  }
}
